import { FadeIn } from "@/components/FadeIn";
import { SectionHeading, GoldDivider } from "@/components/SectionHeading";
import { Separator } from "@/components/ui/separator";

export default function Impressum() {
    return (
        <div className="min-h-screen">
            {/* Hero Section */}
            <section className="relative py-20 md:py-28 bg-gradient-to-b from-background to-muted/30">
                <div className="container mx-auto px-4 max-w-4xl">
                    <FadeIn>
                        <SectionHeading
                            title="Impressum"
                            subtitle="Angaben gemäß § 6 TMG"
                        />
                        <GoldDivider />
                    </FadeIn>
                </div>
            </section>

            {/* Content */}
            <section className="py-16 md:py-24">
                <div className="container mx-auto px-4 max-w-3xl space-y-12">
                    {/* Anbieter */}
                    <FadeIn>
                        <div className="space-y-2">
                            <p className="font-sans text-foreground leading-relaxed">
                                Ruberto Steuerberatung
                                <br />
                                Neuhauser Str. 27
                                <br />
                                80331 München
                            </p>
                        </div>
                    </FadeIn>

                    <Separator />

                    {/* Kontakt */}
                    <FadeIn>
                        <div className="space-y-2">
                            <h2 className="font-serif text-2xl font-semibold text-foreground">
                                Kontakt
                            </h2>
                            <p className="font-sans text-foreground leading-relaxed">
                                Tel.: 089 / 401 929 200
                                <br />
                                Fax: 089 / 131 007
                                <br />
                                <a
                                    href="mailto:info@steuerkanzlei-ruberto.de"
                                    className="text-primary hover:underline"
                                >
                                    info@steuerkanzlei-ruberto.de
                                </a>
                            </p>
                        </div>
                    </FadeIn>

                    <Separator />

                    {/* Steuerberater */}
                    <FadeIn>
                        <div className="space-y-2">
                            <h2 className="font-serif text-2xl font-semibold text-foreground">
                                Steuerberater
                            </h2>
                            <p className="font-sans text-foreground leading-relaxed">
                                Mario Ruberto, Steuerberater
                                <br />
                                DE249017779
                            </p>
                        </div>
                    </FadeIn>

                    <Separator />

                    {/* Streitschlichtung */}
                    <FadeIn>
                        <div className="space-y-3">
                            <h2 className="font-serif text-2xl font-semibold text-foreground">
                                Streitschlichtung
                            </h2>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Die Europäische Kommission stellt eine Plattform zur
                                Online-Streitbeilegung (OS) bereit:{" "}
                                <a
                                    href="https://ec.europa.eu/consumers/odr"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-primary hover:underline break-all"
                                >
                                    https://ec.europa.eu/consumers/odr
                                </a>
                                .
                                <br />
                                Unsere E-Mail-Adresse finden Sie oben im Impressum.
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Wir sind nicht bereit oder verpflichtet, an
                                Streitbeilegungsverfahren vor einer
                                Verbraucherschlichtungsstelle teilzunehmen.
                            </p>
                        </div>
                    </FadeIn>

                    <Separator />

                    {/* Haftung für Inhalte */}
                    <FadeIn>
                        <div className="space-y-3">
                            <h2 className="font-serif text-2xl font-semibold text-foreground">
                                Haftung für Inhalte
                            </h2>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
                                Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
                                verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
                                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
                                gespeicherte fremde Informationen zu überwachen oder nach
                                Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
                                hinweisen.
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
                                Informationen nach den allgemeinen Gesetzen bleiben hiervon
                                unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
                                Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
                                möglich. Bei Bekanntwerden von entsprechenden
                                Rechtsverletzungen werden wir diese Inhalte umgehend
                                entfernen.
                            </p>
                        </div>
                    </FadeIn>

                    <Separator />

                    {/* Haftung für Links */}
                    <FadeIn>
                        <div className="space-y-3">
                            <h2 className="font-serif text-2xl font-semibold text-foreground">
                                Haftung für Links
                            </h2>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Unser Angebot enthält Links zu externen Websites Dritter, auf
                                deren Inhalte wir keinen Einfluss haben. Deshalb können wir
                                für diese fremden Inhalte auch keine Gewähr übernehmen. Für
                                die Inhalte der verlinkten Seiten ist stets der jeweilige
                                Anbieter oder Betreiber der Seiten verantwortlich. Die
                                verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf
                                mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte
                                waren zum Zeitpunkt der Verlinkung nicht erkennbar.
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Eine permanente inhaltliche Kontrolle der verlinkten Seiten
                                ist jedoch ohne konkrete Anhaltspunkte einer
                                Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
                                Rechtsverletzungen werden wir derartige Links umgehend
                                entfernen.
                            </p>
                        </div>
                    </FadeIn>

                    <Separator />

                    {/* Urheberrecht */}
                    <FadeIn>
                        <div className="space-y-3">
                            <h2 className="font-serif text-2xl font-semibold text-foreground">
                                Urheberrecht
                            </h2>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Die durch die Seitenbetreiber erstellten Inhalte und Werke
                                auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die
                                Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                                Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen
                                der schriftlichen Zustimmung des jeweiligen Autors bzw.
                                Erstellers. Downloads und Kopien dieser Seite sind nur für
                                den privaten, nicht kommerziellen Gebrauch gestattet.
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Soweit die Inhalte auf dieser Seite nicht vom Betreiber
                                erstellt wurden, werden die Urheberrechte Dritter beachtet.
                                Insbesondere werden Inhalte Dritter als solche
                                gekennzeichnet. Sollten Sie trotzdem auf eine
                                Urheberrechtsverletzung aufmerksam werden, bitten wir um
                                einen entsprechenden Hinweis. Bei Bekanntwerden von
                                Rechtsverletzungen werden wir derartige Inhalte umgehend
                                entfernen.
                            </p>
                        </div>
                    </FadeIn>
                </div>
            </section>
        </div>
    );
}
